import { Component } from '@angular/core';

@Component({
  selector: 'red-empty-layout',
  templateUrl: './empty-layout.component.html',
  styleUrls: ['./empty-layout.component.scss'],
})
export class EmptyLayoutComponent {}
